module.exports = __webpack_public_path__ + "img/haiwan-propa.671ef1f4.png";